export const ACTION_TYPE = Object.freeze({
    SEND_TEMPLATE: 'send_template',
    REPLY_WHATSAPP: 'reply_whatsapp',
    SEND_EMAIL: 'send_email',
    CREATE_TASK: 'create_task',
    CREATE_APPOINTMENT: 'create_appointment',
    CALL: 'call',
    AI_CALL: 'ai_call',
} as const);

export const ACTION_ERROR = Object.freeze({
    LEAD_MISMATCH: 'lead_mismatch',
    MISSING_AGENT: 'missing_agent',
    UNSUPPORTED_ACTION: 'unsupported_action',
    INVALID_DRAFT: 'invalid_draft',
    EXECUTION_FAILED: 'execution_failed',
    ABORTED: 'aborted',
    TIMEOUT: 'timeout',
} as const);

export const APPOINTMENT_ACTION = Object.freeze({
    DRIVE: 'drive',
    DELIVERY: 'delivery',
    DOCUMENTATION: 'documentation',
    CALLING: 'calling',
    MAILING: 'mailing',
    INFORMATION: 'information',
} as const);

export const DEFAULT_APPOINTMENT_DURATION_MINUTES = 60;
export const MINUTES_PER_HOUR = 60;
export const APPOINTMENT_DATE_STRING_FORMAT = 'DD MMMM YYYY HH:mm a';

export const TASK_FOLLOW_UP_ACTION = 'follow-up';

export const CALL_COMMENT_ACTION = 'call';
export const CALL_FOLLOW_UP_DELAY_MINUTES = 5;

export const AI_CALL_POLL_INTERVAL_MS = 3000;
export const AI_CALL_MAX_WAIT_MS = 10 * 60 * 1000;
export const AI_CALL_STATUS = Object.freeze({
    COMPLETED: 'completed',
    FAILED: 'failed',
} as const);

export type TActionType = (typeof ACTION_TYPE)[keyof typeof ACTION_TYPE];
export type TActionError = (typeof ACTION_ERROR)[keyof typeof ACTION_ERROR];
export type TAppointmentAction =
    (typeof APPOINTMENT_ACTION)[keyof typeof APPOINTMENT_ACTION];
